import PropTypes from 'prop-types'
import { CameraStatus } from '../../models/cameras/camera-status'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { vehicleObjectPropType } from '../vehicle/vehicle-object-prop-type'

/**
 * @typedef {Object} CameraOverview
 * @property {string} [cameraId]                     - Id of the camera.
 * @property {string} [cameraImei]                   - CameraImei of the camera.
 * @property {string} [serialNumber]                 - SerialNumber of the camera.
 * @property {string} [objectName]                   - Name of the object the camera is attached to.
 * @property {string} [objectNumber]                 - Number of the object the camera is attached to.
 * @property {string} [driverName]                   - Name of the driver the camera is attached to.
 * @property {string} [cameraStatus]                 - Status of the camera, can be one of FRONT, DRIVER, AUXILIARY
 * @property {Position} [locationText]               - Last location of the camera.
 * @property {iso8601DateTimeSting} [lastSeenOnline] - The time when the camera was seen online last time in ISO8601 UTC format.
 * @property {string} [cameraFirmware]               - Firmware version of the camera
 * @property {VehicleObject} [wfObject]              - Vehicle object data
 */
export const cameraOverviewPropType = PropTypes.shape({
    cameraImei: PropTypes.string.isRequired,
    serialNumber: PropTypes.string.isRequired,
    cameraId: PropTypes.string.isRequired,
    objectName: PropTypes.string,
    objectNumber: PropTypes.string,
    driverName: PropTypes.string,
    cameraStatus: PropTypes.oneOf(Object.values(CameraStatus)).isRequired,
    lastSeenOnline: iso8601PropType,
    locationText: PropTypes.shape({
        locationDescription: locationDescriptionPropType,
        position: positionPropType
    }),
    cameraFirmware: PropTypes.string,
    wfObject: vehicleObjectPropType
})
